import EventEmitter from './EventEmitter.js'

export default class Time extends EventEmitter
{
    constructor()
    {
        super()

        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 0.016 // bug if 0 
        

        window.requestAnimationFrame(() =>
        {
            this.tick()
        })
    }
    

    tick()
    {
        const currentTime = Date.now()
        this.delta = (currentTime - this.current) / 1000
        this.current = currentTime
        this.elapsed = (this.current - this.start) / 1000

        this.trigger('tick')
        
        window.requestAnimationFrame(() =>
        {
            this.tick()
        })
    }

}